import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_contractor_users/list`),
    params: param,
  });
};

const ForemanList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_contractor_users/registable_list`),
    params: param,
  });
};

const UnregisteredList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_contractor_users/unregistered_list`),
    params: param,
  });
};

const createContractorUserIntegrate = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_contractor_users/create_integrate`),
    data,
  });
};

const checkExistRelativeBuildeeData = (fieldId, fieldContractorUserId) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${fieldId}/field_contractor_users/${fieldContractorUserId}/exist_relative_buildee_data`,
  });
};

const updateStatusUser = (fieldId, fieldContractorUserId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/${fieldId}/field_contractor_users/${fieldContractorUserId}/update_status`,
    data,
  });
};

const updateOrder = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/${fieldId}/field_contractor_users/list`,
    data: param,
  });
};

export const FieldContractorUserService = {
  list,
  ForemanList,
  UnregisteredList,
  createContractorUserIntegrate,
  checkExistRelativeBuildeeData,
  updateStatusUser,
  updateOrder,
};
export default FieldContractorUserService;



// WEBPACK FOOTER //
// ./src/services/FieldContractorUsers.js